import { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { Button, Card, Col, Row, Modal } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { deleteGroup, getGroup } from "../../../redux/action/groups";
import { deleteOtherType } from "../../../redux/action/otherType"; // ⚠️ đảm bảo đúng path

const { confirm } = Modal; // ✅ FIX QUAN TRỌNG

function ListCategory() {
  const { t } = useTranslation();
  const { groupList } = useSelector((state) => state.group);

  const [loading, setLoading] = useState(true);

  /* ================= FETCH DATA ================= */
  const fetchData = async () => {
    try {
      setLoading(true);
      await dispatch(getGroup());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= DELETE ================= */
  const handleDelete = (e: React.MouseEvent, id: number) => {
    e.preventDefault(); // ⛔ chặn Link
    e.stopPropagation(); // ⛔ chặn bubble

    confirm({
      title: "Xác nhận xoá",
      content: "Bạn có chắc chắn muốn xoá banner này không?",
      okText: "Xoá",
      okType: "danger",
      cancelText: "Huỷ",
      onOk: async () => {
        try {
          await dispatch(deleteGroup(id)); // gọi API xoá
          fetchData(); // reload list
        } catch (error) {
          console.error(error);
        }
      },
    });
  };

  /* ================= RENDER ================= */
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <TitleComponent
            title="Danh sách danh mục"
            type="primary"
            data="Tạo mới"
            icon={<PlusOutlined />}
            to="/Category/Data/Create"
            isExist={true}
          />

          {groupList.map((item) => {
            const firstImage = item.image;

            return (
              <Link to={`/Category/Data/${item.groupId}`} key={item.groupId}>
                <Card className="layoutItem" style={{ marginBottom: 16 }}>
                  <Row gutter={[20, 20]}>
                    {/* INFO */}
                    <Col xs={24} md={12}>
                      <div>
                        <p className="tilteForm">{t("Tên danh mục")}</p>
                        <p className="descForm">{item.groupName}</p>
                      </div>

                      <div style={{ marginTop: 16 }}>
                        <p className="tilteForm">{t("Mô tả")}</p>
                        <p className="descForm">{item.description}</p>
                      </div>

                      <Button
                        style={{ marginTop: 30 }}
                        type="primary"
                        onClick={(e) => {
                          if (!item.groupId) return;
                          handleDelete(e, item.groupId);
                        }}
                      >
                        Xoá danh mục
                      </Button>
                    </Col>

                    {/* IMAGE */}
                    <Col xs={24} md={12}>
                      {firstImage ? (
                        <img
                          src={firstImage}
                          alt="group"
                          style={{
                            width: "100%",
                            height: 320,
                            borderRadius: 10,
                            marginTop: 14,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: 180,
                            marginTop: 14,
                            borderRadius: 10,
                            background: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontStyle: "italic",
                          }}
                        >
                          Không có ảnh
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card>
              </Link>
            );
          })}
        </>
      )}
    </div>
  );
}

export default ListCategory;
